export const BLOGS_PER_PAGE = 10
